export class Formats {

  static DATE_FORMAT = "MMM D, YYYY";
  static TIME_FORMAT = "h:mma";

  static ClassDateFormat = "ddd D MMM YY h:mm a";

  static DATE_TIME_FORMAT = `${Formats.DATE_FORMAT} ${Formats.TIME_FORMAT}`;
}
